export default "__VITE_ASSET__DCSN9Bif__"